import styled from "styled-components";
import { Button } from "../Button/Button";
import { Color } from "../../styles/Colors";

export const ReportsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ReportsHeader = styled.div`
  font-family: "Lato";
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  text-align: left;
  color: ${Color.darkGray};
  display: flex;
  gap: 6px;
`;

export const TableContainer = styled.div`
  display: flex;
  gap: 16px; /* space between tables */
  flex-wrap: nowrap; /* keep them side by side */
  overflow-x: auto; /* scroll if too many tables */
  padding-bottom: 4px; /* little space for scrollbar */
`;

export const TableWrapper = styled.div`
  flex: 0 0 420px; /* fixed width for each table */
  background: #f8faff; /* light background */
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
`;
